<template>
  <div class="home-lobby">
    <header class="sr-only">
      <h1>ThinKaHa — online slots, fishing games, Shan Koe Mee, Bugyi, live casino and card games</h1>
    </header>
    <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
    <!-- <div class="col-12 d-flex my-0">
      <img
        class="mx-auto"
        src="https://cdn.gold549.com/build/assets/img/brand/logo.png"
        alt=""
        style="width: 120px; height: 120px; margin-top: -22px"
      />
    </div> -->

    <div class="home-sticky-header">
      <NavBar />

      <HomeBanner />

      <div
        class="col-12 d-flex align-items-center px-0 px-3 mx-auto my-0 home-notice-bar"
        style="z-index: 10; padding-top: 2px; padding-bottom: 2px; background: linear-gradient(90deg, #FA610B 0%, #F88D14 100%) !important; border-top: 1px solid rgba(232, 197, 71, 0.35); border-bottom: 1px solid rgba(232, 197, 71, 0.25);"
      >
        <button
          type="button"
          class="home-notice-bar__music"
          :class="{ 'is-on': $store.state.isMusicPlaying, 'is-off': !$store.state.musicEnabled }"
          :aria-label="$store.state.musicEnabled ? 'Mute music' : 'Play music'"
          :title="$store.state.musicEnabled ? 'Stop music' : 'Play music'"
          @click.stop="toggleNoticeMusic"
        >
          <i
            class="fas"
            :class="$store.state.musicEnabled ? 'fa-volume-up' : 'fa-volume-mute'"
          ></i>
        </button>
        <span class="home-notice-bar__label">{{ $t('home.music') }}</span>
        <NoticeBar
          class="mx-0 px-0 notice-bar"
          scrollable
          :text="websiteInfo.noticeText"
          v-if="!threedData.embedded_link && !threedData.isLive"
        />
        <!-- websiteInfo[0]?.noticeText  -->
      </div>

      <!-- <div class="my-3 text-center py-2" style="background: #F4DC83; font-weight: 900; color: black;">
        TOP GAMES
      </div> -->
    </div>


    <div class="cards-container-mobile">
      <div class="container-fluid home-game-layout px-0 pt-0">
        <!-- <div class="col-12"> -->

        <div class="pr-0 mx-0 pl-2 index_left sidebar">
          <ul class="nav nav-pills game-nav">
            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon home-nav-chip d-flex flex-column p-2"
                :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                style="padding-top: 0.6rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                @click="changeSideNav('hot');"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/thingaha/icon1.avif"
                  class="mx-auto p-0 m-0 pr-1"
                  style="cursor: pointer; width: 2.5rem;"
                >
                <span
                  class="mt-1 mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                >{{ $t('home.hot') }}</span>
              </div>
            </li>
            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon home-nav-chip d-flex flex-column p-2 pt-0"
                :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
                style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                @click="changeSideNav('buffalo');"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/thingaha/icon2.avif"
                  class="mx-auto p-0 m-0 pulse"
                  style="cursor: pointer; width: 2.5rem;"
                >
                <!-- <img v-show="$store.state.sideNav === 'buffalo'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0c75648c-b244-4972-a288-6e11ca52f100/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                <span
                  class="mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
                >{{ $t('home.buffalo') }}</span>
              </div>
            </li>
            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon home-nav-chip d-flex flex-column p-2 pt-0"
                :class="$store.state.sideNav === 'card' ? 'active' : ''"
                style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                @click="changeSideNav('card');"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/thingaha/icon3.avif"
                  class="mx-auto p-0 m-0 pulse"
                  style="cursor: pointer; width: 2.5rem;"
                >
                <!-- <img v-show="$store.state.sideNav === 'card'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0c75648c-b244-4972-a288-6e11ca52f100/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                <span
                  class="mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'card' ? 'active' : ''"
                >{{ $t('home.card') }}</span>
              </div>
            </li>
            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon home-nav-chip d-flex flex-column p-2"
                :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                style="padding-top: 0.6rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                @click="changeSideNav('slot');"
              >
                <!-- <img v-show="$store.state.sideNav !== 'slot'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/75b1ab42-51bc-408a-56cd-85ec16303d00/public" class="mx-auto p-0 ml-2" style="cursor: pointer; width: 3rem;"> -->
                <img
                  src="https://storage.googleapis.com/spacetech2/thingaha/icon4.avif"
                  class="mx-auto p-0 ml-2 pulse"
                  style="cursor: pointer; width: 2.5rem;"
                >
                <span
                  class="mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                >{{ $t('home.slot') }}</span>
              </div>
            </li>
            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon home-nav-chip d-flex flex-column p-2"
                :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                style="padding-top: 1rem !important;width: 90%; height: 6rem; border-radius: 10px;"
                @click="changeSideNav('fishing');"
              >
                <!-- <img v-show="$store.state.sideNav !== 'fishing'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/1c9d8b71-8e10-4dbc-a3f4-6eb1b6631b00/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                <img
                  src="https://storage.googleapis.com/spacetech2/thingaha/icon5.avif"
                  class="mx-auto p-0 m-0 pulse"
                  style="cursor: pointer; width: 2.5rem;"
                >
                <span
                  class="mt-1 mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                >{{ $t('home.fishing') }}</span>
              </div>
            </li>
            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon home-nav-chip d-flex flex-column p-2 pt-0"
                :class="$store.state.sideNav === 'lottery' ? 'active' : ''"
                style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                @click="changeSideNav('lottery');"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/thingaha/icon8.avif"
                  class="mx-auto p-0 m-0 pulse"
                  style="cursor: pointer; width: 2.5rem;"
                >
                <span
                  class="mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'lottery' ? 'active' : ''"
                >{{ $t('home.lottery') }}</span>
              </div>
            </li>
            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon d-flex flex-column p-2 pt-0"
                :class="$store.state.sideNav === 'football' ? 'active' : ''"
                style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                @click="changeSideNav('football');"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/thingaha/icon7.avif"
                  class="mx-auto p-0 m-0 pulse"
                  style="cursor: pointer; width: 3rem;"
                >
                <span
                  class="mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'football' ? 'active' : ''"
                >{{ $t('home.football') }}</span>
              </div>
            </li>
            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon home-nav-chip d-flex flex-column p-2 pt-0"
                :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                @click="changeSideNav('casino');"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/thingaha/icon6.avif"
                  class="mx-auto p-0 m-0 pulse"
                  style="cursor: pointer; width: 3rem;"
                >
                <span
                  class="mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                >{{ $t('home.casino') }}</span>
              </div>
            </li>

            <li class="nav-item d-flex mt-2">
              <div
                class="side-nav-icon home-nav-chip d-flex flex-column p-2 pt-0"
                :class="$store.state.sideNav === 'download' ? 'active' : ''"
                style="padding-top: 0.8rem !important; width: 90%; height: 5rem; border-radius: 10px;"
                @click="changeSideNav('download');"
              >
                <img
                  v-show="$store.state.sideNav !== 'download'"
                  src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/cd795506-1111-41aa-135a-561223d42600/public"
                  class="mx-auto p-0 m-0"
                  style="cursor: pointer; width: 2rem;"
                >
                <img
                  v-show="$store.state.sideNav === 'download'"
                  src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/cd795506-1111-41aa-135a-561223d42600/public"
                  class="mx-auto p-0 m-0"
                  style="cursor: pointer; width: 2rem;"
                >
                <span
                  class="mx-auto side-nav-icon-text"
                  :class="$store.state.sideNav === 'download' ? 'active' : ''"
                >{{ $t('home.download') }}</span>
              </div>
            </li>
          </ul>
        </div>

        <div
          class="index_rightbar mr-0 pl-0 col-10 pl-0 pr-1"
          id="index_rightbar"
        >
          <div
            class="tab-content game home-game-panel"
            style="min-height: 50vh; border-radius: 20px; height: auto;"
          >

            <div
              class="mx-1 mt-0"
              :class="$store.state.sideNav === 'hot' ? 'active' : ''"
              v-show="$store.state.sideNav === 'hot'"
            >
              <div>
                <section class="home-section col-12 p-0 py-2">
                  <h2 class="home-section__title">{{ $t('home.popular_games') }}</h2>
                  <div class="home-game-grid">
                    <button
                      v-for="bGame in buffaloHotGames"
                      :key="bGame.id"
                      type="button"
                      class="home-game-tile"
                      @click="(bGame.provider === 'PGSoft' || bGame.provider === 'FaChai') ? showAlertBox(bGame) : gameInit(bGame)"
                    >
                      <span
                        class="home-game-tile__hot"
                        aria-hidden="true"
                      >
                        <img
                          src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                          alt=""
                        >
                      </span>
                      <div class="home-game-tile__thumb">
                        <img
                          :src="bGame.image"
                          :alt="bGame.name || 'Game'"
                          loading="lazy"
                        />
                      </div>
                      <span class="home-game-tile__name">{{ bGame.name }}</span>
                    </button>

                    <button
                      type="button"
                      class="home-game-tile"
                      @click="changeSideNav('skm')"
                    >
                      <span
                        class="home-game-tile__hot"
                        aria-hidden="true"
                      >
                        <img
                          src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                          alt=""
                        >
                      </span>
                      <div class="home-game-tile__thumb">
                        <img
                          src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bufalo688_skm.webp"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                    </button>
                    <button
                      type="button"
                      class="home-game-tile"
                      @click="changeSideNav('bgy')"
                    >
                      <span
                        class="home-game-tile__hot"
                        aria-hidden="true"
                      >
                        <img
                          src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                          alt=""
                        >
                      </span>
                      <div class="home-game-tile__thumb">
                        <img
                          src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/buffalo688_bgy.webp"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                    </button>
                    <button
                      type="button"
                      class="home-game-tile"
                      @click="fetchGaloneData()"
                    >
                      <span
                        class="home-game-tile__hot"
                        aria-hidden="true"
                      >
                        <img
                          src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                          alt=""
                        >
                      </span>
                      <div class="home-game-tile__thumb">
                        <img
                          src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/buffalo688_galone.webp"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                    </button>
                    <!-- <button
                        type="button"
                        class="home-game-tile"
                        @click="fetchForestData()"
                      >
                        <span
                          class="home-game-tile__hot"
                          aria-hidden="true"
                        >
                          <img
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                            alt=""
                          >
                        </span>
                        <div class="home-game-tile__thumb">
                          <img
                            src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/buffalo688_forest.webp"
                            alt=""
                            loading="lazy"
                          />
                        </div>
                      </button> -->
                  </div>
                </section>
                <section class="home-section col-12 p-0 py-2">
                  <h2 class="home-section__title">{{ $t('home.popular_slot_games') }}</h2>
                  <div class="home-game-grid">
                    <button
                      v-for="slotGame in hotGames['slotGames']"
                      :key="slotGame.id"
                      type="button"
                      class="home-game-tile"
                      @click="gameInit(slotGame)"
                    >
                      <span
                        class="home-game-tile__hot"
                        aria-hidden="true"
                      >
                        <img
                          src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                          alt=""
                        >
                      </span>
                      <div class="home-game-tile__thumb">
                        <img
                          :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                          :alt="slotGame.name || 'Game'"
                          loading="lazy"
                        />
                      </div>
                      <span class="home-game-tile__name">{{ slotGame.name }}</span>
                    </button>
                  </div>
                </section>

                <section class="home-section col-12 p-0 py-1">
                  <h2 class="home-section__title">{{ $t('home.popular_fishing_games') }}</h2>
                  <div class="home-game-grid">
                    <button
                      v-for="slotGame in hotGames['fishingGames']"
                      :key="slotGame.id"
                      type="button"
                      class="home-game-tile"
                      @click="(slotGame.provider === 'PGSoft' || slotGame.provider === 'FaChai') ? showAlertBox(slotGame) : gameInit(slotGame)"
                    >
                      <span
                        class="home-game-tile__hot"
                        aria-hidden="true"
                      >
                        <img
                          src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                          alt=""
                        >
                      </span>
                      <div class="home-game-tile__thumb">
                        <img
                          :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                          :alt="slotGame.name || 'Game'"
                          loading="lazy"
                        />
                      </div>
                      <span class="home-game-tile__name">{{ slotGame.name }}</span>
                    </button>
                  </div>
                </section>

                <section class="home-section col-12 p-0 py-1">
                  <h2 class="home-section__title">{{ $t('home.popular_arcade_games') }}</h2>
                  <div class="home-game-grid">
                    <button
                      v-for="slotGame in hotGames['arcadeGames']"
                      :key="slotGame.id"
                      type="button"
                      class="home-game-tile"
                      @click="(slotGame.provider === 'PGSoft' || slotGame.provider === 'FaChai') ? showAlertBox(slotGame) : gameInit(slotGame)"
                    >
                      <span
                        class="home-game-tile__hot"
                        aria-hidden="true"
                      >
                        <img
                          src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                          alt=""
                        >
                      </span>
                      <div class="home-game-tile__thumb">
                        <img
                          :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                          :alt="slotGame.name || 'Game'"
                          loading="lazy"
                        />
                      </div>
                      <span class="home-game-tile__name">{{ slotGame.name }}</span>
                    </button>
                  </div>
                </section>
              </div>
            </div>



            <!-- <div class="mx-1" :class="this.$store.state.sideNav === 'vs' ? 'active' : ''" v-show="this.$store.state.sideNav === 'vs'">
                    <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/723ca88a-6cf0-406b-d7b3-a93d023f6f00/public" alt="slot" style="cursor: pointer; width: 103%; margin-left: -0.4rem; height: auto;" @click="gameInit('CockFight')">
                  </div> -->

            <div
              :class="$store.state.sideNav === 'skm' ? 'active' : ''"
              v-if="$store.state.sideNav === 'skm'"
            >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                alt="skm"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchShanKoMeeData(0)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                alt="skm"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchShanKoMeeData(1)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                alt="skm"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchShanKoMeeData(2)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                alt="skm"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchShanKoMeeData(3)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                alt="skm"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchShanKoMeeData(4)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                alt="skm"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchShanKoMeeData(5)"
              >
            </div>

            <div
              :class="$store.state.sideNav === 'bgy' ? 'active' : ''"
              v-if="$store.state.sideNav === 'bgy'"
            >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                alt="bgy"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchBugyee(0)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                alt="bgy"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchBugyee(1)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                alt="bgy"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchBugyee(2)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                alt="bgy"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchBugyee(3)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                alt="bgy"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchBugyee(4)"
              >
              <img
                class="mx-1 my-1"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                alt="bgy"
                style="cursor: pointer; width: 47.5%; height: auto;"
                @click="fetchBugyee(5)"
              >
            </div>

            <div
              class="d-flex justify-content-between flex-wrap mt-3"
              :class="$store.state.sideNav === 'lottery' ? 'active' : ''"
              v-if="$store.state.sideNav === 'lottery'"
            >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/2D.avif"
                alt="lottery"
                class="my-2 px-0 mx-0"
                style="cursor: pointer; width: 100%; height: auto;"
                @click="$router.push('/user/2d/home')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/3D.avif"
                alt="lottery"
                class="my-2 px-0 mx-0"
                style="cursor: pointer; width: 100%; height: auto;"
                @click="$router.push('/user/3d/home')"
              >
              <img
                src="/assets/tgh-voucher.webp"
                alt="Slips"
                class="my-2 px-0 mx-0"
                style="cursor: pointer; width: 100%; height: auto;"
                @click="$router.push({ path: '/betslip-history', query: { type: 'twod' } })"
              >
            </div>

            <div
              :class="$store.state.sideNav === 'card' ? 'active' : ''"
              v-if="$store.state.sideNav === 'card'"
              class="pb-2 mx-0 px-0 d-flex flex-wrap"
            >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Card-SKM.avif"
                alt="card"
                class="col-12 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="changeSideNav('skm')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Card-BuGyi.avif"
                alt="card"
                class="col-12 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="changeSideNav('bgy')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Card-Forest.avif"
                alt="card"
                class="col-12 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="fetchForestData()"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Card-Galone.avif"
                alt="card"
                class="col-12 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="fetchGaloneData()"
              >
            </div>

            <div
              :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
              v-if="$store.state.sideNav === 'buffalo'"
            >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-Buffalo.avif"
                alt="skm"
                class="px-0 mx-0"
                style="cursor: pointer; width: 100%; height: auto;"
                @click="$router.push('/user/slots?provider=Buffalo')"
              >
            </div>

            <div
              :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
              v-if="$store.state.sideNav === 'fishing'"
              class="home-provider-grid pb-2 mx-0 px-0 d-flex flex-wrap"
            >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Fish-FC.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/fishing?provider=FaChai')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Fish-AW.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/fishing?provider=AceWin')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Fish-Jili.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/fishing?provider=Jili')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Fish-2J.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/fishing?provider=2J')"
              >
              <!-- <img
                src="/assets/Fish%201.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/fishing?provider=Spade')"
              > -->
              <!-- <img src="https://storage.googleapis.com/spacetech2/abc777/RICH88%20Fish.webp" alt="skm" class="col-6 px-1 py-1 px-0 mx-0" style="cursor: pointer; height: auto;" @click="$router.push('/user/fishing?provider=Rich88')"> -->
              <!-- <img
                src="/assets/Fish%201.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0 home-provider-banner"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/fishing?provider=BTG')"
              > -->
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Fish-JDB.avif"
                class="col-6 px-1 py-1 px-0 mx-0"
                alt="skm"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/fishing?provider=JDB')"
              >

              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Fish-KA.avif"
                class="col-6 px-1 py-1 px-0 mx-0"
                alt="skm"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/fishing?provider=KA')"
              >

            </div>

            <div
              :class="$store.state.sideNav === 'slot' ? 'active' : ''"
              v-if="$store.state.sideNav === 'slot'"
              class="home-provider-grid pb-2 mx-0 px-0 d-flex flex-wrap"
            >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-PP.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=Pragmatic')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-PG.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=PGSoft')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-Jili.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=Jili')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-2J.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=2J')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-JDB.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=JDB')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-BNG.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=BNG')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-Live22.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=Live22')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-VA.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=VA')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-FC.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=FaChai')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-HD.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=HotDog')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-AW.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=AceWin')"
              >
              <!-- <img
                src="https://storage.googleapis.com/spacetech2/abc777/BT%20Slot.webp"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=BTG')"
              > -->
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-PS.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=Playstar')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-5G.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=5G')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-Rich.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=Rich')"
              >
              
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-R88.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=Rich88')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Slot-KA.avif"
                alt="skm"
                class="col-6 px-1 py-1 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/user/slots?provider=KA')"
              >

            </div>

            <div
              :class="$store.state.sideNav === 'football' ? 'active' : ''"
              v-if="$store.state.sideNav === 'football'"
              class="home-provider-grid pb-2 mx-0 px-0 d-flex flex-wrap"
            >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Football-Body.avif"
                alt="Body football"
                class="col-6 my-2 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/body-fb')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Football-Maung.avif"
                alt="Maung football"
                class="col-6 my-2 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/maung-fb')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Football-Live.avif"
                alt="Live football"
                class="col-6 my-2 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/live')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Football-Result.avif"
                alt="Match results"
                class="col-6 my-2 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push('/football-result')"
              >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Football-Voucher.avif"
                alt="Betslip history"
                class="col-6 my-2 px-0 mx-0"
                style="cursor: pointer; height: auto;"
                @click="$router.push({ path: '/betslip-history', query: { type: 'maung' } })"
              >
            </div>

            <div
              :class="$store.state.sideNav === 'casino' ? 'active' : ''"
              v-if="$store.state.sideNav === 'casino'"
            >
              <img
                src="https://storage.googleapis.com/spacetech2/thingaha/Cards/Casino-PP.avif"
                alt="casino"
                class="my-2 px-0 mx-0"
                style="cursor: pointer; width: 100%; height: auto;"
                @click="gameInitCasino('PP Live')"
              >
              <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/Sexy%20Live%20copy.png" alt="casino" class="my-2 px-0 mx-0" style="cursor: pointer; width: 100%; height: auto;" @click="gameInitCasino('Sexy')">
                    <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/wm%20casino%20copy.png" alt="casino" class="my-2 px-0 mx-0" style="cursor: pointer; width: 100%; height: auto;" @click="gameInitCasino('WM')">
                    <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/BG%20Casino%20copy.png" alt="skm" class="my-2 px-0 mx-0" style="cursor: pointer; width: 100%; height: auto;" @click="gameInitCasino('BG')"> -->
            </div>

            <div
              :class="$store.state.sideNav === 'download' ? 'active' : ''"
              v-if="$store.state.sideNav === 'download'"
            >
              <div class="gwrap_1 pb-3">
                <h4 class="text-center text-dark mt-3">{{ $t('home.you_download') }} <br> {{
                  $t('home.on_any_platform') }}
                </h4>
                <a
                  href="https://storage.googleapis.com/spacetech2/thingaha/base.apk?ignoreCache=1"
                  download="ThinKaHa.apk"
                >
                  <img
                    src="https://cdn.gold549.com/build/assets/img/brand/android-download.png"
                    alt="android download"
                  >
                  <!-- style="cursor: pointer; width: 50%; height: auto;" -->
                </a>
                <!-- <a
                  href="https://api.abc777.tel/api/app/download/ios"
                  download="abc777.mobileconfig"
                >
                  <img
                    src="https://cdn.gold549.com/build/assets/img/brand/ios-download.png"
                    alt="ios download"
                    style="cursor: pointer; width: 50%; height: auto; margin-top: 0.1rem;"
                  >
                </a> -->
              </div>
            </div>
          </div>
        </div>


        <!-- </div> -->
      </div>

      <footer class="page-footer-copyright mt-4">

        <div
          class="footer-platform num-27 d-flex flex-wrap justify-content-center"
          bis_skin_checked="1"
        >

          <img
            class="ACEWIN"
            src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/ACEWIN-logo.webp"
          >

          <!-- <img
                    class="ADVANTPLAY"
                    src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/ADVANTPLAY-logo.webp"
                  > -->

          <!-- <img
                    class="ILOVEU"
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/iloveu.webp"
                  > -->

          <img
            class="BNG"
            src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/BNG-logo.webp"
          >

          <!-- <img
                    class="DG"
                    src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/DG-logo.webp"
                  > -->

          <img
            class="FACHAI"
            src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/FACHAI-logo.webp"
          >

          <!-- <img
                    class="ALIZE"
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/alize.png"
                  > -->

          <img
            class="JDB"
            src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/JDB-logo.webp"
          >

          <img
            class="JILI"
            src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/JILI-logo.webp"
          >

          <!-- <img
                    class="KINGMIDAS"
                    src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/KINGMIDAS-logo.webp"
                  > -->

          <!-- <img
                    class="MGGAMING"
                    src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/MGGAMING-logo.webp"
                  > -->

          <!-- <img
                    class="MGLIVE"
                    src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/MGLIVE-logo.webp"
                  > -->

          <!-- <img class="MIMI" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/MIMI-logo.webp"> -->

          <!-- <img
                    class="POCKET"
                    src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/POCKET-logo.webp"
                  > -->

          <img
            class="PLAYSTAR"
            src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/PLAYSTAR-logo.webp"
          >

          <img
            class="PP"
            src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/PP-logo.webp"
          >

          <!-- <img class="SEXYBCRT" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/SEXYBCRT-logo.webp"> -->

          <!-- <img
                    class="SPADE"
                    src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/SPADE-logo.webp"
                  > -->

          <!-- <img class="SVCASINO" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/SVCASINO-logo.webp"> -->

          <!-- <img class="SVSPORTS" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/SVSPORTS-logo.webp"> -->

          <img
            class="TWOJGAME"
            src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/TWOJGAME-logo.webp"
          >

          <!-- <img class="VERTEXPLAY" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/VERTEXPLAY-logo.webp"> -->

          <!-- <img class="WM" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/WM-logo.webp"> -->

          <!-- <img class="WMSLOT" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/WMSLOT-logo.webp"> -->

          <!-- <img class="WOS" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/WOS-logo.webp"> -->

          <!-- <img class="YB" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/YB-logo.webp"> -->

          <!-- <img class="CARD365" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/CARD365-logo.webp"> -->

          <img src="https://storage.googleapis.com/spacetech2/general/5G.png">
          <img src="https://storage.googleapis.com/spacetech2/general/HD.png">
          <img src="https://storage.googleapis.com/spacetech2/general/Live22.png">
          <img src="https://storage.googleapis.com/spacetech2/general/R88.png">
          <img src="https://storage.googleapis.com/spacetech2/general/BTG.png">

          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/bgaming_dark.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/evolution_logo.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/EvolutionNetEnt.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/Evoplay.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/Ezugi.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/hanebar.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/hacksaw_logo.webp"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/live88.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/nolimit-logo.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/Play_n%20GO.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/RedTiger.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/SABA%20Sport.png"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/spinomenal.webp"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/turbo_games.webp"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/winfinity_logo.webp"> -->
          <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/Yeebet.webp"> -->



        </div>

        <div
          class="page-wrapper"
          style="display:none"
          bis_skin_checked="1"
        >
          <div
            class="brand-area socialnum-0"
            bis_skin_checked="1"
          >


          </div>
        </div>
        <div
          class="page-wrapper mt-3"
          bis_skin_checked="1"
        >
          <div
            class="txt-copyright customInfo"
            bis_skin_checked="1"
          >
            <h3><b>မြန်မာနိုင်ငံရဲ့ အကောင်းဆုံးနဲ့ ဝန်ဆောင်မှု</b></h3><br /> ငွေကြေးယုံကြည်စိတ်ချ နာမည်ပျက်မရှိ သင်္ဂဟ
            ဂိမ်းဆိုဒ် <br /> နေ့စဥ်ကျပ်သိန်း ၁၀၀ထိ ငွေထုတ်ကန်သတ်ချက်မရှိ
            ထုတ်ပေးနေတဲ့ဂိမ်းဆိုဒ်<br />
            ငွေသွင်း-ငွေထုတ် မြန်ဆန်ပြီး Customer Service ၂၄ နာရီ
            ပိတ်ရက်မရှိ ဆက်သွယ်ရန် <br />
            Telegram Support: <a
              href="https://t.me/ThinKaHaLucky7_bot"
              bis_skin_checked="1"
            >@ThinKaHaLucky7_bot</a><br />
            သင့်အချက်အလတ်များကို လုံခြုံစွာကာကွယ်ထားပြီး ယုံကြည်မှု အပြည့်ဖြင့် ဝန်ဆောင်မှုပေးနေပါပြီးရှင့်
          </div>
          <div
            class="txt-copyright"
            bis_skin_checked="1"
          ><br> © ThinKaHa All rights Reserved<br>All content, image, and logo are respected property of
            ThinKaHa
            and protected by copyright law.</div>
          <div
            class="txt-support"
            bis_skin_checked="1"
          >
            <p>Our platform is most compatible with:</p>
            <div class="browser-badges d-flex justify-content-center">
              <span class="badge browser-badge text-center">
                <img
                  src="https://land2.mpsimg.com/theme/images/src-common/FOOTER-img/browser/chrome.png"
                  alt="Google Chrome"
                >
                <span>Google Chrome</span>
              </span>
              <span class="badge browser-badge text-center">
                <img
                  src="https://land2.mpsimg.com/theme/images/src-common/FOOTER-img/browser/safari.png"
                  alt="Safari"
                >
                <span>Safari</span>
              </span>
            </div>
          </div>
          <div
            class="policy-area-menu"
            bis_skin_checked="1"
          ><a
              class="txt-link"
              onclick="#"
            >Responsible Gaming Policy</a><a
              class="txt-link"
              onclick="#"
            >21+ Responsible Gaming</a></div>
        </div>
      </footer>
    </div>


    <van-overlay :show="isLoading">
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#ffffff"
          class="mx-auto"
        />
      </div>
    </van-overlay>

    <!-- <LiveChatWidget license="18638211" v-if="testing"/> -->

    <div class="col-4">
      <div
        class="modal fade"
        id="limit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        style="z-index: 100000 !important;"
        @click="hideLimit()"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered"
          role="document"
        >
          <div
            class="modal-content"
            style="z-index: 200000 !important;"
          >
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>အထူးသတိပြုရန်။</b> <br><br>

                {{ isLoading }}
              </span>
              <span>{{ limitText }}</span>
              <br><br> <span class="text-dark text-sm">
                <button
                  class="btn btn-danger"
                  @click="gameInit(desiredGame)"
                >
                  {{
                    $store.state.language === "en"
                      ? "Play The Game"
                      : "ဂိမ်းဆော့မည်။"
                  }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import NavBar from '@/layouts/NavBar.vue';
import HomeBanner from '@/pages/frontend/components/HomeBanner.vue';
import { NoticeBar, Dialog, Toast } from 'vant';
import { mapActions } from 'vuex';
import { LiveChatWidget } from '@livechat/widget-vue';

export default {
  components: { NoticeBar, LiveChatWidget, HomeBanner },
  data() {
    return {
      testing: true,
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {
        home_banners: {}
      },
      isLogged: false,
      hotGames: {
        slotGames: [],
        fishingGames: [],
        arcadeGames: [],
      },
      buffaloHotGames: [
        {
          id: 1,
          image: "https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/african-buffalo-new.webp",
          gameID: "african-buffalo-new",
          gameName: "African Buffalo New",
          gameTypeID: "vs",
          provider: "AfricanBuffalo",
          is_close: false,
          hot: true,
        },
        {
          id: 2,
          image: "https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/african-buffalo-new.webp",
          gameID: "african-buffalo-new",
          gameName: "African Buffalo New",
          gameTypeID: "vs",
          provider: "AfricanBuffalo",
          is_close: false,
          hot: true,
        },
        {
          id: 3,
          image: "https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/african-buffalo-old.webp",
          gameID: "african-buffalo-old",
          gameName: "African Buffalo Old",
          gameTypeID: "vs",
          provider: "AfricanBuffalo",
          is_close: false,
          hot: true,
        },
        {
          id: 4,
          image: "https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/african-buffalo-scatter.webp",
          gameID: "african-buffalo-scatter",
          gameName: "African Buffalo Scatter",
          gameTypeID: "vs",
          provider: "AfricanBuffalo",
          is_close: false,
          hot: true,
        },
        {
          id: 5,
          image: "https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/african-buffalo-scatter.webp",
          gameID: "african-buffalo-scatter",
          gameName: "African Buffalo Scatter",
          gameTypeID: "vs",
          provider: "AfricanBuffalo",
          is_close: false,
          hot: true,
        }
      ],
      limitText: '',
      desiredGame: null,
    };
  },
  destroyed() {
    this.testing = false;
  },
  methods: {
    toggleNoticeMusic() {
      this.$store.commit('toggleMusicEnabled');
    },
    async fetchForestData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/forest-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          this.$store.commit('setIframeURL', res.data.data.gameUrl);
          this.$store.commit('setIframeMobileView', true);
          this.$router.push('/iframeURL');
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchGaloneData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/galone-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          this.$store.commit('setIframeURL', res.data.data.gameUrl);
          this.$store.commit('setIframeMobileView', true);
          this.$router.push('/iframeURL');
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    hideLimit() {
      $('#limit').modal('hide');
    },
    showAlertBox(game) {
      if (game.provider === 'PGSoft') this.limitText = 'PG Soft တွင် 1K unit သည် 1,000 ကျပ်နှင့်ညီမျပါသည်။';
      else if (game.provider === 'FaChai') this.limitText = 'FaChai Provider တွင် 1 unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      // else this.limitText = '5G Provider တွင် 1K unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      $('#limit').modal('show');
      this.desiredGame = game;
    },

    async gameInit(game) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const providerID = game.provider;
        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            provider: providerID,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const data = res?.data?.data ?? res?.data ?? {};
        const apiDescription =
          data?.description ??
          res?.data?.description ??
          data?.message ??
          res?.data?.message ??
          '';
        let gameUrl =
          data.gameUrl ??
          data.game_url ??
          data.url ??
          res?.data?.gameUrl ??
          res?.data?.url ??
          '';
        gameUrl = String(gameUrl || '').trim();

        // console.log("GAME URL", gameUrl);

        // PGSoft (and some providers) return HTML instead of a URL: render via blob URL
        let rawHtml =
          data.html ??
          res?.data?.html ??
          (typeof res?.data === 'string' && res.data.trimStart().startsWith('<')
            ? res.data
            : null) ??
          (gameUrl && gameUrl.trimStart().startsWith('<') ? gameUrl : null);
        if (!rawHtml) rawHtml = '';
        if (rawHtml && typeof rawHtml === 'string') {
          const blob = new Blob([rawHtml], { type: 'text/html;charset=utf-8' });
          gameUrl = URL.createObjectURL(blob);
        } else if (gameUrl && !gameUrl.startsWith('blob:')) {
          gameUrl += gameUrl.includes('?') ? '&' : '?';
        }

        if (gameUrl) {
          this.$store.commit('setIframeURL', gameUrl);
          this.$router.push('/iframeURL');
        } else {
          Dialog.alert({
            message: apiDescription,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },

    isPWA() {
      return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true ||
        document.referrer.startsWith('android-app://')
      );
    },

    async gameInitCasino(game) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const res = await axios.get('/games/url', {
          params: {
            provider: game,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          this.$store.commit('setIframeURL', res.data.data.gameUrl);
          this.$router.push('/iframeURL');
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },

    imageLinkGenerate(gameId, type) {
      if (type === 'Jili') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
      } if (type === 'Live22') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${gameId}.webp`;
      } if (type === 'Spade') {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
      } if (type === 'Fastspin') {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      } if (type === 'Playstar') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${gameId}.webp`;
      } if (type === 'FaChai') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${gameId}.webp`;
      } if (type === 'PGSoft') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${gameId}.webp`;
      } if (type === 'JOKER' || type === 'Joker') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
      } if (type === '5G') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${gameId}.webp`;
      } if (type === 'KA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${gameId}.webp`;
      } if (type === 'AceWin') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${gameId}_EN.webp`;
      } if (type === 'JDB') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${gameId}.webp`;
      } if (type === 'Buffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
      } if (type === 'HotDog') {
        return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
      } if (type === 'Rich') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${gameId}.webp`;
      } if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
      } if (type === 'BTG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${gameId}.webp`;
      } if (type === '2J') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${gameId}.webp`;
      } if (type === 'VA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${gameId}_en.webp`;
      } if (type === 'BNG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${gameId}.webp`;
      } if (type === 'AfricanBuffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
      }

      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
    },
    scrollToElement() {
      const scrollContainer = this.$el.closest('.index-scroll-main');
      const target = this.$el.querySelector('#index_rightbar')
        || this.$el.querySelector('.home-game-layout');
      if (!scrollContainer || !target) return;

      const stickyHeader = this.$el.querySelector('.home-sticky-header');
      const stickyOffset = stickyHeader ? stickyHeader.offsetHeight : 0;

      const targetTop = target.getBoundingClientRect().top;
      const containerTop = scrollContainer.getBoundingClientRect().top;
      const scrollTop = scrollContainer.scrollTop + (targetTop - containerTop) - stickyOffset;

      scrollContainer.scrollTo({
        top: Math.max(0, scrollTop),
        behavior: 'smooth',
      });
    },
    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;

        if (game) {
          this.gameName = game
          this.gameLink = link
        }
        const res = await axios.get(`/${this.gameName}-data`, {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          }
        });
        const gameUrl = `https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`;
        this.$store.commit('setIframeURL', gameUrl);
        this.$router.push('/iframeURL');
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async fetchBugyee(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText = "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText = "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText = "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText = "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText = "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText = "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        const res = await axios.get('/bugyee-data', {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        // this.$store.commit('setIframeURL', res.data.data.gameUrl);
        // this.$router.push('/iframeURL');

        if (res.data?.data?.gameUrl) {
          this.$store.commit('setIframeURL', res.data.data.gameUrl);
          this.$router.push('/iframeURL');
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },

    async fetchShanKoMeeData(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText = "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          // $('#limit').modal('show');
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText = "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText = "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText = "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText = "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText = "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get('/shankomee-data', {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          this.$store.commit('setIframeURL', res.data.data.gameUrl);
          this.$router.push('/iframeURL');
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },
    // async gameInit(game) {
    //   try {
    //     this.isLoading = true;
    //     const authUser = await this.fetchUser();
    //     if (!authUser) {
    //       this.$router.push('/auth/login');
    //     }

    //     const res = await axios.get('/games/url', {
    //       params: {
    //         provider: game
    //       },
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('token')}`,
    //       },
    //     });

    //     window.open(res.data.data.gameUrl, "_self");
    //     // this.$store.commit('setIframeURL', res.data.data.gameUrl);
    //     // this.$store.commit('setIsCardGame', false);
    //     // this.$router.push('/iframeURL');

    //     this.isLoading = false;
    //   } catch (error) {
    //     this.isLoading = false;
    //     // this.$router.go();
    //   }
    // },
    changeSideNav(para) {
      if (para === 'buffalo') {
        this.$router.push('/user/slots?provider=Buffalo');
        return;
      }
      this.$store.commit('updateSideNav', para);
      this.$nextTick(() => {
        this.scrollToElement();
      });
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    async redirectRoute(path, query = null) {
      try {
        console.log('query', query)
        if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },

    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    async redirectRoute(path, query = null) {
      try {
        if (path === 'tip') {
          const text = this.$store.state.language === 'en'
            ? 'This feature is not support yet.'
            : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
          Dialog.alert({
            message: text,
            confirmButtonText:
              this.$store.state.language === 'en'
                ? 'Okay'
                : 'Okay',
          }).then(() => {
            // on close
          });
        } else if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get('/2d/data');
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get('/3d/data');
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHotGames() {
      try {
        const res = await axios.get('/hot-games');
        this.hotGames = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get('/twod_history');
        const threeDres = await axios.get('/threed_history');
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Function to load the Tawt.io chat widget
    // loadTawkChat() {
    //   console.log('here1')
    //   if (!document.getElementById('tawk-io-chat')) {
    //     console.log('here2')
    //     var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();

    //     // Dynamically add the script to load Tawt.io
    //     var s1 = document.createElement("script");
    //     var s0 = document.getElementsByTagName("script")[0];
    //     s1.async = true;
    //     s1.id = 'tawk-io-chat';
    //     s1.src = 'https://embed.tawk.to/66ed95584cbc4814f7dc1919/1i880up29';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');
    //     s0.parentNode.insertBefore(s1, s0);

    //     // Apply custom styles when the widget loads
    //     Tawk_API.onLoad = () => {
    //       this.applyCustomStyles();
    //       setInterval(this.applyCustomStyles, 1000);
    //     };
    //   }
    // },
    // Function to apply custom styles to the Tawk.to iframe
    applyCustomStyles() {
      var tawkIframe = document.querySelector('iframe[title="chat widget"]');
      if (tawkIframe) {
        tawkIframe.style.bottom = '7rem'; // Adjust this as needed
        tawkIframe.style.left = '1rem';
        tawkIframe.style.right = '0rem';
      }
    },
    // Function to remove the Tawt.io script and widget
    removeTawkChat() {
      const tawkScript = document.getElementById('tawk-io-chat');
      if (tawkScript) {
        tawkScript.remove(); // Remove the script tag
      }

      // Remove the Tawk.to iframe widget
      const tawkIframe = document.querySelector('iframe[title="chat widget"]');
      if (tawkIframe) {
        tawkIframe.remove();
      }
    }
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    await this.fetchWebsiteData();
    await this.fetchHotGames();
    this.$store.commit('setLoading', false);
  },
  beforeDestroy() {
    this.removeTawkChat();
  }
};
</script>
<style scoped>
/* Footer */
footer.page-footer-copyright {
  font-size: 80%;
  text-align: center;
  /* color: #ffffffa4; */
  position: relative;
  width: 100%;
  flex: 0 0 100%;
  padding: 0 0 60px 0;
}

.home-game-layout {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  width: 100%;
}

/* footer.page-footer-copyright {
  font-size: 80%;
  text-align: center;
  color: #ffffffa4;
  position: relative;
  padding: 0 0 60px 0;
}
 footer.page-footer-copyright {
  font-size: 80%;
  text-align: center;
  color: #ffffffa4;
  position: relative;
  padding: 0 0 60px 0;
} */

.footer-platform {
  display: block;
  padding: 1% 2%;
  margin: 0 auto 1% auto;
  text-align: center;
  position: relative;
}

.footer-platform img,
.page-wrapper img {
  width: 55px;
  margin: 0 5px;
  height: 40px;
  object-fit: contain;
}

footer.page-footer-copyright .txt-support {
  display: inline-block;
  border-radius: 15px;
  /* background-color: rgba(0, 0, 0, 0.3); */
  padding: 10px;
  margin: 0 auto;
  /* color: #ffffff7a; */
}

footer.page-footer-copyright .txt-support .badge {
  margin-right: 10px;
  line-height: 25px;
  padding: 0;
  font-weight: normal;
  font-size: 12px;
}

footer.page-footer-copyright .txt-support .browser-badges {
  gap: 16px;
}

footer.page-footer-copyright .txt-support .browser-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 0;
  line-height: 1.3;
}

footer .txt-support .browser-badge img,
.modal-content .txt-support .browser-badge img {
  width: 28px;
  height: 28px;
  margin: 0 0 4px 0;
  vertical-align: unset;
}

footer .txt-support .badge img,
.modal-content .txt-support .badge img {
  width: 20px;
  height: 20px;
  margin-right: 3px;
  vertical-align: middle;
}

.page-web.M9 .page-wrapper {
  background: rgba(13, 38, 34, 0.7);
}

footer.page-footer-copyright .page-wrapper {
  font-size: 12px;
  background: transparent !important;
}

.page-web .page-wrapper {
  width: 100%;
  margin: 0 auto;
}

footer .page-wrapper,
.modal-content .page-wrapper {
  padding: 0;
}

.txt-link {
  color: #924AFF !important;
}


/* —— Game lobby: indigo + orange + gold —— */
.home-lobby {
  min-height: 100vh;
  padding-bottom: 15rem;
  background:
    radial-gradient(ellipse 120% 50% at 50% -5%, rgba(250, 97, 11, 0.28) 0%, transparent 55%),
    linear-gradient(180deg, #1A1428 0%, #12101C 42%, #0D0B14 100%);
  background-attachment: fixed;
}

/* Sticky header: stays within the mobile column (unlike Vant Sticky position:fixed) */
.home-sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  background: #12101C;
}

/* Full-bleed banner: no strong tint behind slides (fade / letterboxing) */
.home-banner {
  max-width: 100%;
  overflow: hidden;
  background: #12101C;
}

.home-banner__carousel,
.home-banner ::v-deep .carousel,
.home-banner ::v-deep .carousel-inner {
  width: 100%;
  height: auto !important;
}

.home-banner ::v-deep .carousel-inner,
.home-banner ::v-deep .carousel-item {
  background: #12101C !important;
  border-radius: 0 !important;
}

.home-banner ::v-deep .carousel-item img,
.home-banner ::v-deep img {
  width: 100%;
  height: auto !important;
  object-fit: contain;
  border-radius: 0 !important;
  display: block;
}

/* Fade carousel: size from active slide only — prevents full-viewport height jumps */
.home-banner ::v-deep .carousel-fade .carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.home-banner ::v-deep .carousel-fade .carousel-item.active {
  position: relative;
}

.home-game-panel {
  /* background: rgba(255, 255, 255, 0.88); */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  /* border: 1px solid #e2e8f0; */
  box-shadow: none;
}

.home-section {
  margin-bottom: 0.15rem;
}

.home-section__title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #E8C547;
  margin: 0 0 12px;
  padding: 0 0 8px 0;
  border-left: none;
  border-bottom: 1px solid rgba(201, 162, 39, 0.35);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.35;
}

.home-game-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.home-game-tile {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 0.7rem;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.15s ease;
  text-align: center;
}

.home-game-tile:active {
  transform: scale(0.97);
}

.home-game-tile__thumb {
  border-radius: 0.7rem;
  overflow: hidden;
  background: #1E1A32;
  border: none;
  box-shadow: none;
  transition: transform 0.2s ease;
}

.home-game-tile:hover .home-game-tile__thumb,
.home-game-tile:focus-visible .home-game-tile__thumb {
  transform: translateY(-1px);
  box-shadow: none;
}

.home-game-tile:focus-visible {
  outline: 2px solid #E8C547;
  outline-offset: 2px;
}

.home-game-tile__thumb img {
  display: block;
  width: 100%;
  height: auto;
  min-height: 88px;
  object-fit: cover;
  aspect-ratio: 3 / 4;
}

.home-game-tile__hot {
  position: absolute;
  top: -8px;
  right: -4px;
  z-index: 2;
  width: 26px;
  pointer-events: none;
}

.home-game-tile__hot img {
  width: 100%;
  height: auto;
  display: block;
}

.home-game-tile__name {
  margin-top: 6px;
  font-size: 0.62rem;
  font-weight: 600;
  color: #F4F0E8;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding: 0 2px;
}

.home-nav-chip.side-nav-icon:not(.active) {
  background: #1E1A32 !important;
  color: #F4F0E8 !important;
  border: 1px solid rgba(232, 197, 71, 0.22) !important;
  box-shadow: none;
}

.home-nav-chip:not(.active) .side-nav-icon-text {
  color: #F4F0E8 !important;
}

.home-provider-grid img {
  border-radius: 0.7rem;
  /* border: 1px solid rgba(231, 98, 41, 0.08); */
  box-sizing: border-box;
  transition: transform 0.18s ease, border-color 0.18s ease;
  box-shadow: none;
}

.home-provider-grid img:hover {
  border-color: #E8C547;
}

.home-provider-grid img:active {
  transform: scale(0.98);
}

.home-provider-banner {
  border-radius: 0.7rem !important;
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.side-nav-icon-text {
  /* color: #E76229; */
  font-size: 0.9rem;
  /* color: #382618; */
}

.side-nav-icon {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  font-weight: 600;
  color: #F4F0E8 !important;
  box-shadow: none;
  border: 1px solid rgba(232, 197, 71, 0.22);
  background: #1E1A32;
}

.side-nav-icon.active {
  border-color: rgba(232, 197, 71, 0.65);
  background: linear-gradient(135deg, #FA610B 0%, #F88D14 100%);
  color: white !important;
  box-shadow: 0 4px 14px rgba(231, 98, 41, 0.4);
}

.side-nav-icon-text.active {
  color: white !important;
}

.sidebar {
  position: sticky;
  top: 0;
  flex: 0 0 20%;
  max-width: 20%;
  align-self: flex-start;
  max-height: 100vh;
  padding-bottom: 50px;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
  overflow-y: auto;
}

.index_rightbar {
  flex: 1;
  min-width: 0;
  padding: 0px 0px;
  height: auto;
  overflow: visible;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 1px solid #E76229;
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  color: #E8C547;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background: linear-gradient(135deg, #FA610B 0%, #F88D14 100%);
  border-color: #E8C547;
  box-shadow: none;
  transform: none;
}

.detail-button:active {
  box-shadow: none;
  transform: none;
}

.nav-pills.game-nav {
  padding-right: 5px;
}

.nav-pills .nav-link {
  border-radius: 10px !important;
  margin-bottom: 5px;
  /* padding: 10px; */
  font-size: 10px !important;
  text-align: center;
  color: #ffffff;
  /* background: linear-gradient(#aa9ace, #714DC7); */
}

.nav-pills:not(.nav-pills-circle) .nav-item {
  padding-right: 0;
  margin-bottom: 0;
  width: 100px;
}

.nav-pills .nav-link img {
  width: 18px !important;
  /* margin-right: 10px; */
  padding-bottom: 4px;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff !important;
  background: linear-gradient(#fff, #8a69d9);
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.tab-content.game a img {
  /* box-shadow: 0px 3px 14px -5px rgba(0, 0, 0, 0.4); */
  border-radius: 21px;
  margin-bottom: 10px;
  width: 100%;
}

.tab-content.game {
  padding-left: 3px;
}

.tab-content>.tab-pane {
  display: none;
  padding-right: 3px;
}

.tab-content>.active {
  display: block;
}


.css-38745a {
  margin: 0px;
  line-height: 1.5;
  font-size: 12px;
  font-family: NotoSansMyanmar;
  font-weight: 500;
}

.css-17h40hp {
  margin: 0px;
  line-height: 1.5;
  font-size: 14px;
  font-family: NotoSansMyanmar;
  font-weight: 700 !important;
}

.card {
  cursor: pointer;
  border-radius: 10px !important;
}

.main-image-wrapper img {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 0 !important;
  display: block;
}

.video-container {
  height: 500px;
  width: 100%;
}

.home-notice-bar__music {
  display: inline-flex;
  flex: 0 0 26px;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin-right: 8px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  color: #FA610B;
  box-shadow: 0 0 12px rgba(255, 242, 168, 0.45);
  font-size: 12px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.15s ease, background 0.15s ease, opacity 0.15s ease;
  animation: notice-icon-pulse 2.4s ease-in-out infinite;
  position: relative;
  z-index: 1;
}

.home-notice-bar__music:active {
  transform: scale(0.94);
}

.home-notice-bar__music.is-off {
  background: rgba(0, 0, 0, 0.28);
  box-shadow: none;
  animation: none;
  color: rgba(255, 255, 255, 0.75);
}

.home-notice-bar__label {
  flex: 0 0 auto;
  margin-right: 10px;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

@keyframes notice-icon-pulse {

  0%,
  100% {
    box-shadow: 0 0 8px rgba(255, 242, 168, 0.3);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 0 16px rgba(255, 242, 168, 0.6);
    transform: scale(1.06);
  }
}

.notice-bar {
  margin-top: -40px;
  z-index: 1;
  font-size: 20px;
  color: #E8C547;
  background: transparent;
  border-radius: 0 !important;
}

.notice-bar ::v-deep .van-notice-bar {
  border-radius: 0 !important;
}

.twod-threed-cards {
  height: 200px;
}

.live-number {
  font-weight: bold;
  font-size: 25px;
}

.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.not-live-text {
  font-weight: bold;
  font-size: 24px;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
}

.card-body {
  padding: 0px !important;
}

.cards-container-mobile {
  display: none;
}

@keyframes live-number-animation {
  from {
    color: white;
  }

  to {
    color: orange;
  }
}

/* @media (max-width: 768px) { */
/* .middle-container {
    padding-top: 0.1rem !important;
  } */
hr {
  margin-top: 0px;
  margin-bottom: 0px;
}

.video-container {
  height: 300px;
  width: 100%;
}

.main-wrapper {
  padding: 7px !important;
}

.notice-bar {
  flex: 1 1 auto;
  width: 0;
  min-width: 0;
  margin-top: 0px;
  height: 25px;
  z-index: 1;
  font-size: 12px;
  color: white;
  background: transparent;
  border-radius: 0 !important;
}

.live-number {
  font-weight: bold;
  font-size: 20px;
}

.live-result {
  font-weight: bolder;
  font-size: 37px;
}

.cards-container {
  display: none;
}

.cards-container-mobile {
  padding: 0px !important;
  margin-top: 5px !important;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
}

.home-cards {
  padding-left: 10px;
  padding-right: 10px;
}

.card-body {
  padding: 0px !important;
}

.not-live-text {
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.account-container-wrapper {
  width: auto;
  height: auto;
  border-radius: 10px;
  padding-left: 4px;
  padding-right: 4px;
  margin-top: 10px !important;
  margin-left: 10px;
  margin-right: 10px;
  color: #F4F0E8;
  border: 1px solid rgba(232, 197, 71, 0.35);
  box-shadow: 0 4px 14px rgba(13, 11, 20, 0.35);
}

.top-wrapper,
.bottom-wrapper {
  padding: 10px;
  width: 100%;
  display: flex;
}

.top-right,
.bottom-right {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: end;
}

.top-left,
.bottom-left {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: start;
}

@media (prefers-reduced-motion: reduce) {
  .home-notice-bar__music {
    animation: none !important;
  }
}

/* } */
</style>
